export const getEndUserTokenKeyByHandler = (handler) => `${handler}_endUserToken`